module.exports = __webpack_public_path__ + "static/js/forms.2fc4f508.chunk.worker.js"